import { getMoment } from './getMoment';

export const getElapsedTimeFromUtcDate = (date: string, withoutSuffix?: boolean): string => {
    return getMoment().utc(date).local().fromNow(withoutSuffix);
};
